/**
 * Colors from Figma design system
 * Last updated: May 4, 2025
 */

export const sharedColors = {
  // Brand Colors
  white: "#FFFFFF",
  black: "#000000",
  green: "#39B54A",
  darkGreen: "#194F20",
  lightGreen: "#E8F7EE",
  ecru: "#DDB771",
  mediumGrey: "#313237",
  grey: "#6F6F6F",
  lightGrey: "#F3F3F3",

  // System Colors
  successGreen: "#007544",
  successGreenLight: "#D2EFE2",
  errorRed: "#B83A00",
  errorRedLight: "#FFDFD0",

  // Gradients
  gradients: {
    greenGradient: "linear-gradient(to right, #194F20, #39B549)",
  },

  // Drop shadows for consistent elevation effects
  dropShadow: {
    main: "8px 8px 30px rgba(2, 39, 87, 0.16)",
    mainSmall: "-8px 8px 30px rgba(15, 36, 79, 0.12)",
    light: "0px 0px 9px rgba(0, 0, 0, 0.06)",
    header: "0px 4px 16px rgba(90, 90, 90, 0.05)",
  },
}
